import React from 'react';

export interface ITabItem {
    id: string;
    label: string;
    disabled?: boolean;
};

export interface TabContainerProps {
    items: ITabItem[];
    activeTab: string;
    onChange: (tabId: string) => void;
    className?: string;
    variant?: 'default' | 'navigation' | 'content';
};

export interface TabItemProps extends ITabItem {
    isActive: boolean;
    onClick: () => void;
    className?: string;
};

const TabItem: React.FC<TabItemProps> = ({
    id,
    label,
    isActive,
    disabled,
    onClick,
    className = '',
}) => {
    const baseClass = 'immersion__tabs__item';
    const classes = [
        baseClass,
        isActive ? `${baseClass}--active` : '',
        disabled ? `${baseClass}--disabled` : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <button
            className={classes}
            onClick={onClick}
            disabled={disabled}
            type="button"
            data-tab-id={id}
            id={`tab-${id}`}
            aria-selected={isActive}
            role="tab"
        >
            {label}
        </button>
    );
};

const TabContainer: React.FC<TabContainerProps> = ({
    items,
    activeTab,
    onChange,
    className = '',
    variant = 'default'
}) => {
    const baseClass = 'immersion__tabs';
    const containerClasses = [
        baseClass,
        variant !== 'default' ? `${baseClass}--${variant}` : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <div className={containerClasses}>
            {items.map((item) => (
                <TabItem
                    key={item.id}
                    {...item}
                    isActive={activeTab === item.id}
                    onClick={() => !item.disabled && onChange(item.id)}
                />
            ))}
        </div>
    );
};

export { TabContainer, TabItem };